var angular = require('angular');
var _module = require('./index');

_module.directive('meetYourRep', [function () {
    return {
        restrict: 'E',
        templateUrl: 'js/components/modals/templates/meet-your-rep.tmpl.html',
        scope: {
            isMobile: '=',
            sdr: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: [
            function() {
                var vm = this;

            }
        ]
    };
}]);
